import Client from 'App/resources/Model/Client';
import { Feature, isAvailable } from 'App/services/FeatureHelperStandalone';
import AlertConfirm from 'Components/Dialogs/AlertConfirm';
import AlertBody from 'Components/Dialogs/Body/AlertBody';
import React from 'react';
import T from 'Components/Helpers/translate';
import openModal from 'App/services/Modal';
import { getConfirmationTitle } from 'App/components/Alerts/ConfirmationTexts';
import AppService from 'App/legacy/AppService';

export const calculateRelationsCount = (client: Client, subsidiaries: { metadata: { total: number } }) => {
	const inCompanyGroup = () => {
		const hasProspectingPro = isAvailable(Feature.PROSPECTING_PRO);
		const hasProspectingBasic = isAvailable(Feature.PROSPECTING_BASIC);
		const hasGroupSize = isAvailable(Feature.GROUP_SIZE);
		const hasCompanyGroupCard = isAvailable(Feature.COMPANY_GROUP_CARD);
		const showCommercial = !hasGroupSize && !hasProspectingPro && hasProspectingBasic;

		if (client.prospecting && hasCompanyGroupCard && hasProspectingPro) {
			return 0;
		} else if (client.prospecting && (showCommercial || hasProspectingPro)) {
			return client.prospecting.groupSize > 1 ? 1 : 0;
		}

		return 0;
	};

	const parentRelationsCount = client.parent?.id ? 1 : 0;

	return client.connectedClients.length + subsidiaries.metadata.total + inCompanyGroup() + parentRelationsCount;
};

export const confirmDeleteClient = (client: Client) => {
	const customerId = AppService.getCustomerId();
	const alertOptions = {
		type: 'confirm',
		reactive: true,
		fullscreen: true,
		hideAbort: false,
		dialog: AlertConfirm,
		id: 'confirm-delete-fields',
		body: React.createElement(AlertBody, {
			account: client,
			customerId: client.id,
			entity: 'Client',
			numSelected: 1
		}),
		confirmButtonText: T('admin.modal.deleteEntityAndRelated', { entity: T('account') }),
		confirmClass: 'btn-red',
		confirmationMode: 'text',
		confirmText: client.name,
		confirmFn: () =>
			Tools.Account.customer(customerId)
				.delete(client)
				.then(() => {
					// Fine for now, should go somewhere else in final version
					Tools.$state.go('accounts', {});
				})
	};

	openModal('Alert', {
		...alertOptions,
		title: getConfirmationTitle('Client', 1, client.name),
		onClose: confirmed => {
			if (confirmed) {
				alertOptions.confirmFn();
			}
		}
	});
};
